import React, { Component } from 'react';
// import ReactGA from "react-ga"; TODO: mhz
import Moment from 'moment';
import 'moment/locale/es';
import MesSalida from '../inputs/mes-salida/selectMesSalida';
import DropDownDistribucion from '../inputs/habitaciones/dropdownDistribucionHabitaciones';
import Commons from '../../../commons/commons';
import InputSearch from '../../../commons/searcher/input-search';
import './buscador.css';
import { Url } from '../../../api/http-client';

class Buscador extends Component {
  constructor(props) {
    super(props);
    const urlString = window.location.href;
    const urlObj = new Url(urlString);
    const urlProps = window.location.pathname.split('/');
    const salida = urlObj.searchParams.get('s');
    this.state = {
      /* eslint-disable */
      Origen:
        urlProps[3] !== null
          ? urlProps[3]
            ? urlObj.searchParams.get('origen') !== null
              ? urlObj.searchParams.get('origen')
              : urlProps[3]
            : urlProps[3]
          : urlObj.searchParams.get('origen'),
      Destino: urlObj.searchParams.get('d') !== null ? urlObj.searchParams.get('d') : urlProps[4],
      FechaDesde:
        urlObj.searchParams.get('desde') !== null
          ? urlObj.searchParams.get('desde')
          : Moment(salida).startOf('month').format('YYYY-MM-DD'),
      FechaHasta:
        urlObj.searchParams.get('hasta') !== null
          ? urlObj.searchParams.get('hasta')
          : Moment(salida).endOf('month').format('YYYY-MM-DD'),
      habitaciones: 1,
      mesDescripcion:
        urlObj.searchParams.get('desde') !== null
          ? Moment(Moment(urlObj.searchParams.get('desde'), 'YYYY MM DD').month() + 1, 'M').format(
              'MMMM',
            )
          : Moment(Moment(salida, 'YYYY MM DD').month() + 1, 'M').format('MMMM'),
      lista_habitaciones: [
        {
          adultos: 2,
          menores: 0,
          listaMenores: [],
        },
      ],
      cant_huespedes: 2,
      distribucionHabitacionesDesdeGet: '',
      /* eslint-disable */
    };
    this.actualizarDestino = this.actualizarDestino.bind(this);
    this.actualizarOrigen = this.actualizarOrigen.bind(this);
    this.actualizarMesSalida = this.actualizarMesSalida.bind(this);
    this.prepararDatosHabitaciones = this.prepararDatosHabitaciones.bind(this);
    this.cantidadHabitaciones = this.cantidadHabitaciones.bind(this);
    this.actualizarMenores = this.actualizarMenores.bind(this);
    this.actualizarEdadesMenores = this.actualizarEdadesMenores.bind(this);
    this.actualizarAdultos = this.actualizarAdultos.bind(this);
    this.actualizarHuespedes = this.actualizarHuespedes.bind(this);
    this.contarHuespedes = this.contarHuespedes.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.formatearFecha = this.formatearFecha.bind(this);
  }

  componentWillMount() {
    try {
      const url = new URL(window.location.href);
      const distribucion =
        window.location.pathname.split('/')[6] !== null
          ? window.location.pathname.split('/')[6]
          : url.searchParams.get('h');
      if (distribucion !== null) {
        this.setState({
          distribucionHabitacionesDesdeGet: Commons.obtenerDistribucion(),
        });
      }
    } catch (e) {
      console.error("Can't get distribution");
    }
  }
  componentDidMount() {
    const habitaciones = this.state.distribucionHabitacionesDesdeGet;
    if (habitaciones) {
      if (habitaciones[0].adultos >= 1) {
        this.armarInputDistribucionDefault(habitaciones);
      }
    }
  }
  armarInputDistribucionDefault(habitaciones) {
    const listaHabitaciones = [];
    let cantidadHabitaciones = 0;
    for (let habitacion = 0; habitacion < habitaciones.length; habitacion++) {
      let cantidadMenores = 0;
      const listaMenores = [];
      cantidadHabitaciones++;
      for (
        let numeroMenor = 0;
        numeroMenor < habitaciones[habitacion].menores.length;
        numeroMenor++
      ) {
        listaMenores.push(habitaciones[habitacion].menores[numeroMenor]);
        cantidadMenores++;
      }
      listaHabitaciones.push({
        adultos: habitaciones[habitacion].adultos,
        menores: cantidadMenores,
        listaMenores,
      });
    }
    this.setState({
      lista_habitaciones: listaHabitaciones,
      habitaciones: cantidadHabitaciones,
      cant_huespedes: Commons.obtenerCantidadPasajeros(habitaciones),
    });
  }
  formatearFecha(prop) {
    const fechaSeleccionada = prop;
    const fechaDesdeFormatoMoment = Moment(fechaSeleccionada, 'MM YYYY');
    let FechaDesde = fechaDesdeFormatoMoment.format('YYYY-MM-DD');
    const mesActual = Moment().format('M');
    const mesSeleccionado = fechaDesdeFormatoMoment.format('M');

    if (mesActual === mesSeleccionado) {
      FechaDesde = Moment().format('YYYY-MM-DD');
    }
    this.setState({
      mesDescripcion: Moment(mesSeleccionado, 'M').format('MMMM'),
    });

    const FechaHasta = Moment(fechaSeleccionada, 'MM YYYY').endOf('month').format('YYYY-MM-DD');
    const fecha = { FechaDesde, FechaHasta };
    this.actualizarMesSalida(fecha);
  }
  actualizarDestino(prop) {
    this.setState({
      Destino: prop.code,
    });
  }
  actualizarOrigen(prop) {
    this.setState({
      Origen: prop.code,
    });
  }
  actualizarMesSalida(prop) {
    this.setState({
      FechaDesde: prop.FechaDesde,
      FechaHasta: prop.FechaHasta,
    });
  }
  cantidadHabitaciones(val) {
    this.setState({
      habitaciones: val,
    });
    if (val < this.state.habitaciones) {
      this.state.lista_habitaciones.pop();
    } else {
      const lista_habitaciones = this.state.lista_habitaciones;
      lista_habitaciones[lista_habitaciones.length] = {
        adultos: 2,
        menores: 0,
        listaMenores: [],
      };
      this.setState({ lista_habitaciones });
    }
    this.actualizarHuespedes();
  }

  actualizarMenores(val, nroHabitacion) {
    const listaHabitaciones = this.state.lista_habitaciones;

    if (val < this.state.lista_habitaciones[nroHabitacion].menores) {
      listaHabitaciones[nroHabitacion].listaMenores.pop();
    }

    listaHabitaciones[nroHabitacion].menores = val;

    this.setState({ lista_habitaciones: listaHabitaciones });

    this.actualizarHuespedes();
  }

  actualizarEdadesMenores(event, nro_habitacion) {
    const lista_habitaciones = this.state.lista_habitaciones;

    lista_habitaciones[nro_habitacion].listaMenores[event.target.getAttribute('data-indice')] =
      event.target.value;

    this.setState({ lista_habitaciones });
  }

  actualizarAdultos(val, nro_habitacion) {
    const lista_habitaciones = this.state.lista_habitaciones;

    if (val < this.state.lista_habitaciones[nro_habitacion].adultos) {
      lista_habitaciones[nro_habitacion].listaMenores.pop();
    }

    lista_habitaciones[nro_habitacion].adultos = val;

    this.setState({ lista_habitaciones });

    this.actualizarHuespedes();
  }

  actualizarHuespedes() {
    let cantidadHuespedes = 0;

    cantidadHuespedes = this.contarHuespedes(cantidadHuespedes);

    this.setState({ cant_huespedes: cantidadHuespedes });
  }

  contarHuespedes(cantidadHuespedes) {
    this.state.lista_habitaciones.map(function (elemento) {
      cantidadHuespedes =
        parseInt(cantidadHuespedes) + parseInt(elemento.menores) + parseInt(elemento.adultos);
    });
    return cantidadHuespedes;
  }

  prepararDatosHabitaciones() {
    let habitacionesQueryString = '';

    const habitaciones = this.state.lista_habitaciones;

    for (let i = 0; i < habitaciones.length; i++) {
      habitacionesQueryString += habitaciones[i].adultos;

      if (habitaciones[i].menores > 0) {
        habitaciones[i].listaMenores.map(function (edadMenor) {
          habitacionesQueryString += `-${edadMenor}`;
        });
      }
      if (habitaciones[i + 1]) {
        habitacionesQueryString += '!';
      }
    }
    return habitacionesQueryString;
  }
  submitForm(event) {
    event.preventDefault();
    // TODO: mhz
    // ReactGA.event({
    //     category: "Accion",
    //     action: "Buscar",
    //     label: "Paquetes",
    //     nonInteraction: true,
    // });
    const queryString = this.prepararQueryString(this.state);
    window.location.href = `${process.env.RAZZLE_URL_PATH}/lista-de-paquetes/${this.state.Origen}/${
      this.state.Destino
    }/${this.state.mesDescripcion}/${this.prepararDatosHabitaciones()}${queryString}`;
  }
  prepararQueryString(state) {
    const fechaDesde = `desde=${state.FechaDesde}`;
    const fechaHasta = `hasta=${state.FechaHasta}`;
    return `?${fechaDesde}&${fechaHasta}`;
  }

  render() {
    return (
      <div className="panel panel-default custom buscador">
        <div className="panel-body custom buscador">
          <div className="col-md-2 col-md-offset-1">
            <div className="form-group">
              <div className="selector">
                <InputSearch
                  id="origen"
                  placeHolder="Ingresa un origen"
                  name="origen"
                  onChange={this.actualizarOrigen}
                  defaultInputValue={this.state.Origen}
                />
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <div className="selector">
                <InputSearch
                  id="destino"
                  placeHolder="Ingresa un destino"
                  name="destino"
                  onChange={this.actualizarDestino}
                  defaultInputValue={this.state.Destino}
                />
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <div className="selector">
                <MesSalida
                  mesSalida={Moment(this.state.FechaDesde).format('MM-YYYY')}
                  ActualizarFecha={this.formatearFecha}
                />
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <DropDownDistribucion
                idUnico={this.props.idUnico}
                ancho="100%"
                cantidadHabitaciones={this.cantidadHabitaciones}
                actualizarEdadesMenores={this.actualizarEdadesMenores}
                actualizarAdultos={this.actualizarAdultos}
                actualizarMenores={this.actualizarMenores}
                habitaciones={this.state.habitaciones}
                cant_huespedes={this.state.cant_huespedes}
                lista_habitaciones={this.state.lista_habitaciones}
              />
              <div className="clearfix" />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <button
                onClick={this.submitForm}
                href="#"
                type="submit"
                className="full-width btn-custom"
              >
                Buscar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Buscador;
